var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExpandArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 14,
    viewBox: "0 0 32 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 7H4",
    stroke: "#47D061"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2854 7.42875C15.6091 7.23454 15.6091 6.76545 15.2854 6.57125L11.7572 4.45435C11.424 4.25439 11 4.49445 11 4.8831L11 9.1169C11 9.50555 11.424 9.74561 11.7572 9.54565L15.2854 7.42875Z",
    fill: "#47D061"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7146 6.57125C16.3909 6.76545 16.3909 7.23454 16.7146 7.42875L20.2428 9.54565C20.576 9.74561 21 9.50555 21 9.1169V4.8831C21 4.49445 20.576 4.25439 20.2428 4.45435L16.7146 6.57125Z",
    fill: "#47D061"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28 7H21",
    stroke: "#47D061"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4 1H28V-1H4V1ZM31 4V10H33V4H31ZM28 13H4V15H28V13ZM1 10V4H-1V10H1ZM4 13C2.34315 13 1 11.6569 1 10H-1C-1 12.7614 1.23858 15 4 15V13ZM31 10C31 11.6569 29.6569 13 28 13V15C30.7614 15 33 12.7614 33 10H31ZM28 1C29.6569 1 31 2.34315 31 4H33C33 1.23858 30.7614 -1 28 -1V1ZM4 -1C1.23858 -1 -1 1.23858 -1 4H1C1 2.34315 2.34315 1 4 1V-1Z",
    fill: "#F8F8F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandArrow);
export default __webpack_public_path__ + "static/media/expandArrow.d94040b9e809a661235fa3b3e7603104.svg";
export { ForwardRef as ReactComponent };